export enum ContactUsFormFields {
  name = "name",
  email = "email",
  phone = "phone",
  country = "country",
  role = "role",
  howWeCanHelp = "how_we_can_help",
}

export type ContactUsValues = Record<ContactUsFormFields, string>;

export interface IContacts {
  phone: string;
  email: string;
  working_hours: string;
  address: string;
}
